class YoutubeVideo {  
  constructor() {
    this.videosWrapper = document.querySelectorAll('.youtube-video__video')
    this.init()
  }

  init() {
    for (let i = 0; i < this.videosWrapper.length; i++) {
      const source = 'https://img.youtube.com/vi/' + this.videosWrapper[i].dataset.embed + '/maxresdefault.jpg'

      const image = new Image()
      image.src = source
      image.setAttribute('loading', 'lazy')

      this.videosWrapper[i].appendChild(image)

      this.videosWrapper[i].addEventListener('click', function() {
        const iframe = document.createElement('iframe')
        iframe.setAttribute('frameborder', '0')
        iframe.setAttribute('allowfullscreen', '')
        iframe.setAttribute(
          'src',
          'https://www.youtube.com/embed/' + this.dataset.embed + '?rel=0&showinfo=0&autoplay=1',
        )
        this.innerHTML = ''
        this.appendChild(iframe)
      })
    }
  }
}
  
export default YoutubeVideo
  